import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoadingGkComponent } from '@shared/components/loading/loading.component';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { SharedModule } from '@shared/modules/shared.module';
import { NotFoundComponent } from '@shared/pages/not-found/not-found.component';
import { PaymentRequiredComponent } from '@shared/pages/payment-required/payment-required.component';
import { SkeletonModule } from 'primeng/skeleton';
import { UiButtonsComponent } from './ui-buttons/ui-buttons.component';
import { UiChipsComponent } from './ui-chips/ui-chips.component';
import { UiDatepickerComponent } from './ui-datepicker/ui-datepicker.component';
import { UiFormControlsComponent } from './ui-form-controls/ui-form-controls.component';
import { UiIconStatusComponent } from './ui-icon-status/ui-icon-status.component';
import { UiInputsComponent } from './ui-inputs/ui-inputs.component';
import { UiMultiselectComponent } from './ui-multiselect/ui-multiselect.component';
import { UiOthersComponent } from './ui-others/ui-others.component';
import { UiPasswordComponent } from './ui-password/ui-password.component';
import { UiSearchComponent } from './ui-search/ui-search.component';
import { UiSelectComponent } from './ui-select/ui-select.component';
import { UiSidebarComponent } from './ui-sidebar/ui-sidebar.component';
import { UiTabsComponent } from './ui-tabs/ui-tabs.component';
import { UiTagComponent } from './ui-tag/ui-tag.component';
import { UiTextSizesComponent } from './ui-text-sizes/ui-text-sizes.component';
import { UiTextareaComponent } from './ui-textarea/ui-textarea.component';
import { UiThemeStylesComponent } from './ui-theme-styles/ui-theme-styles.component';
import { UiToastComponent } from './ui-toast/ui-toast.component';

@Component({
	selector: 'app-ui-kit',
	imports: [
		SharedModule,
		UiButtonsComponent,
		UiFormControlsComponent,
		UiIconStatusComponent,
		UiInputsComponent,
		UiPasswordComponent,
		UiSidebarComponent,
		UiTabsComponent,
		UiTagComponent,
		UiTextareaComponent,
		UiTextSizesComponent,
		UiSelectComponent,
		UiMultiselectComponent,
		UiSearchComponent,
		UiChipsComponent,
		UiDatepickerComponent,
		UiThemeStylesComponent,
		LoadingGkComponent,
		SpinnerComponent,
		SkeletonModule,
		UiToastComponent,
		UiOthersComponent,
		NotFoundComponent,
		PaymentRequiredComponent,
	],
	templateUrl: './ui-kit.component.html',
	styleUrl: './ui-kit.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiKitComponent {
	currentSection = signal<string>('theme-styles');
	showLoading = signal<boolean>(true);

	// Textarea FormControls
	textareaControl = new FormControl('');
	disabledTextareaControl = new FormControl({ value: 'This textarea is disabled', disabled: true });
	autoResizeTextareaControl = new FormControl(
		'This textarea will auto-resize as you type more content. Try adding more lines to see it expand automatically.',
	);

	// Select FormControls
	selectControl = new FormControl('');
	disabledSelectControl = new FormControl({ value: 'option2', disabled: true });
	errorSelectControl = new FormControl('');

	// Multiselect FormControls
	multiselectControl = new FormControl([]);
	disabledMultiselectControl = new FormControl({ value: [], disabled: true });
	errorMultiselectControl = new FormControl([]);

	// Search FormControls
	searchControl = new FormControl('');
	disabledSearchControl = new FormControl({ value: 'Spain', disabled: true });
	errorSearchControl = new FormControl('');
	multiselectSearchControl = new FormControl([]);

	// Chips FormControls
	chipsControl = new FormControl<string[]>(['Angular', 'TypeScript']);
	disabledChipsControl = new FormControl<string[]>({ value: ['Disabled', 'Chips'], disabled: true });
	errorChipsControl = new FormControl<string[]>([]);

	// Datepicker FormControls
	datepickerControl = new FormControl(null);
	disabledDatepickerControl = new FormControl({ value: new Date(), disabled: true });
	errorDatepickerControl = new FormControl(null);
	rangeDatepickerControl = new FormControl(null);
	inlineDatepickerControl = new FormControl(null);
	weekViewControl = new FormControl(new Date());
	timeDatepickerControl = new FormControl(null);

	onSectionChange(section: string): void {
		this.currentSection.set(section);
	}
}
